import { NavLink } from 'react-router-dom';

import { PreqinBlackrockLogoWhite } from '@preqin/ui-components/cjs/core/Logo';

import { Workspace } from '@/api/types';

import { ReportTitle } from '../title/ReportTitle';

import { Dropdown } from './Dropdown';
import { DropdownItem } from './DropdownItem';

import styles from './Header.module.scss';

interface Props {
  workspace?: Workspace;
}

export const Header = ({ workspace }: Props) => {
  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <img src={PreqinBlackrockLogoWhite} alt="Preqin Logo" />
        <ReportTitle title={workspace?.workspaceName} isBetaTagEnabled={workspace?.isBetaTagEnabled} />
        <div className={styles.dropdown}>
          <Dropdown
            menuItems={
              <DropdownItem>
                <NavLink to="/signout">Logout</NavLink>
              </DropdownItem>
            }
          />
        </div>
      </div>
    </header>
  );
};
